import {Api, ApiExport} from '../../../Api.js'

const RESOURCE = 'audience'

export default {
    resource: RESOURCE,
    export() {

        /*
        return window.axios({
            url: window.axios.defaults.baseURL + '/' + this.resource + '/export',
            method: 'GET',
            responseType: 'blob', // important
        });*/

        return ApiExport().get(this.resource + '/export',
            {
                responseType: 'blob', // important
            });

    },
    all(query) {
        return Api().get(this.resource + '/all'  + (query ? query : '') )
    },
    contact(filters) {
        return Api().post(this.resource + '/contact', filters)
    },
    query(query) {
        return Api().get(this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.resource, data)
    },
    update(id, data) {
        return Api().put(this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.resource + '/' + id)
    }
}


// WEBPACK FOOTER //
// ./src/modules/campaign/audience/AudienceService.js